export const MARKETPLACE_LABEL = 'Go to Marketplace'
